import { gql, useQuery } from '@apollo/client';
import type { PageComponent } from '../../content/types/types';
import useStoreAndLanguageParams from '../../core/hooks/useStoreAndLanguageParams';
import Storyblok from '../../content/storyblok/storyblok';
import useContentClient from '../../content/hooks/useContentClient';
import { STORYBLOK_ERROR_MESSAGE } from '../../content/constants';

const pageQuery = gql`
    query pageQuery($slug: ID!) {
        PageItem(id: $slug) {
            content {
                body
                component
                title
                version
                attachment {
                    filename
                }
                meta_fields
                full_screen
                short_title
            }
            name
            id
            lang
        }
    }
`;

const useStaticPage = (page: string) => {
    const { store, language } = useStoreAndLanguageParams();

    const client = useContentClient();
    const { data, loading, error } = useQuery<{
        PageItem?: {
            content: PageComponent;
            id: string;
            lang: string;
        };
    }>(pageQuery, {
        variables: {
            slug: Storyblok.formatSlug(store, language, page),
        },
        client,
    });

    if (error) {
        throw new Error(STORYBLOK_ERROR_MESSAGE, { cause: error });
    }

    return {
        data: data?.PageItem?.content,
        loading,
    };
};

export default useStaticPage;
